import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import * as Quill  from 'quill';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { FeedbackService, MsgType } from '../../../_provider/feedback.service';
import { SaveService } from '../../../_provider/save.service';
import { AuthService, ROLE } from '../../../_provider/auth.service';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { WorkstepContent } from '../workstep-content/workstep-content.component';
import { PopoverListItem, PopoverPage } from '../../popover/popover.page';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import QuillBetterTable from 'quill-better-table'
// import { ImageDrop } from 'quill-image-drop-module';
import ImageCompress from 'quill-image-compress';
import TableHandler from 'quill1.3.7-table-module';
import hljs from 'highlight.js'
import { ImageResize } from 'quill-image-resize-module';
import { EmailComposer, OpenOptions } from 'capacitor-email-composer'
import { Subscription } from 'rxjs';
import { Employee } from 'src/app/_interfaces/Employee';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
// import { Userselect, Userselected, UserselectService } from 'src/app/_provider/userselect.service';
import { MultiselectPage } from '../../popover/multiselect/multiselect.page';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { ZeitenService } from 'src/app/_provider/zeiten.service';
import { EditorFormat } from './editor-format.service';
import { EmailTags } from './email-tags.service';
import { EmailService } from 'src/app/_provider/email.service';
import { HttpService } from 'src/app/_provider/http.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { CheckboxSelectComponent, PopoverCheckListItem } from '../../checkbox-select/checkbox-select.component';
import { Attachment } from 'src/app/_interfaces/Attachment';
import { SocketsService } from 'src/app/_provider/sockets.service';
import { CustomerLoginMailSendState } from 'src/app/_pages/new-settings/ticket-settings/customer-login-edit/customer-login-edit.page';
import { ContentTextModulePage } from './content-text-module/content-text-module.page';
import { TextmodulesService, TextSnippet } from 'src/app/_provider/textmodules/textmodules.service';
import "quill-mention";
import { UserselectService } from 'src/app/_provider/userselect.service';

//In der Originalversion der Funktion kommt ein fehler deswegen überschreiben
export class ImageResizeFixed extends ImageResize{
  hideSizeDisplay(){
    return 
  }
}

@Component({
  selector: 'app-content-edit-popup',
  templateUrl: './content-edit-popup.page.html',
  styleUrls: ['./content-edit-popup.page.scss', './editor-toolbar.scss'],
})
export class ContentEditPopupPage extends EditorFormat implements OnInit {

  public customLightmode: boolean = false

  public userSelectSrv: UserselectService

  @ViewChild('emailFileInput', {static: false}) public fileInput: ElementRef
  @Output() closed: EventEmitter<WorkstepContent> = new EventEmitter<WorkstepContent>(undefined)
  @Input() showSettingsSettings: boolean = true
  @Input() public content: WorkstepContent
  @Input() public isNew: boolean = true


  private editTextsSub: Subscription
  private mailSubscription: Subscription

  public ticketSrv: TicketServiceBase

  public isMail: boolean = false 
  public mailTemplateLoading: boolean = true
  public editor: Quill


  public isModal: boolean = false
  public taskId: number


  public isNewArt: EditArt = {
    id: 3,
    description: "Antwort"
  }


  constructor(
    // private navparams: NavParams,
    private modalCtrl: ModalController,
    public darkmode: DarkmodeService,
    public feedback: FeedbackService,
    public generalSrv: GeneralService,
    private saveSrv: SaveService.Ticket,
    private editSrv: TicketEditService,
    private ticketSrvEmployee: TicketEmployee.TicketService,
    private ticketSrvCustomer: TicketCustomer.TicketService,
    public authSrv: AuthService,
    
    private textmodulesSrv: TextmodulesService,
    public emailSrv: EmailService,
    public platform: Platform,
    private ticketEditSrv: TicketEditService,
    public http: HttpService,
    private changeDetector: ChangeDetectorRef,
    public socketSrv: SocketsService,
  ) { 
    super(null, null, socketSrv)
    if(this.authSrv.role == ROLE.employee) this.ticketSrv = ticketSrvEmployee
    else this.ticketSrv = ticketSrvCustomer 
  }
 
  public activeContentFrom: EditArt

  ngOnInit() {   

    this.userSelectSrv = new UserselectService(this.ticketEditSrv.employees)

    Quill.register('modules/imageResize', ImageResizeFixed, true);
    Quill.register('modules/ImageCompress', ImageCompress, true);

    Quill.register({ [`modules/${TableHandler.moduleName}`]: TableHandler }, true);
    
    var DirectionAttribute = Quill.import('attributors/attribute/direction');
    Quill.register(DirectionAttribute, true);
    var AlignClass = Quill.import('attributors/class/align');
    Quill.register(AlignClass, true);
    var BackgroundClass = Quill.import('attributors/class/background');
    Quill.register(BackgroundClass, true);
    var ColorClass = Quill.import('attributors/class/color');
    Quill.register(ColorClass, true);
    var DirectionClass = Quill.import('attributors/class/direction');
    Quill.register(DirectionClass, true);
    var FontClass = Quill.import('attributors/class/font');
    Quill.register(FontClass, true);
    var SizeClass = Quill.import('attributors/class/size');
    Quill.register(SizeClass, true);
    var AlignStyle = Quill.import('attributors/style/align');
    Quill.register(AlignStyle, true);
    var BackgroundStyle = Quill.import('attributors/style/background');
    Quill.register(BackgroundStyle, true);
    var ColorStyle = Quill.import('attributors/style/color');
    Quill.register(ColorStyle, true);
    var DirectionStyle = Quill.import('attributors/style/direction');
    Quill.register(DirectionStyle, true);
    var FontStyle = Quill.import('attributors/style/font');
    Quill.register(FontStyle, true);
    var SizeStyle = Quill.import('attributors/style/size');
    Quill.register(SizeStyle, true);
    
    hljs.configure({
      languages: ["css", "typescript", "javascript", "c#", "html", "xml", "sql", "markdown", "json", "visual basic", "plain text", "java", "swift", "php", "scss", "powershell", "shell session"],
    })

    this.editor = new Quill(`#editor`, {
      modules: {
        [`${TableHandler.moduleName}`]: {},
        toolbar: '#toolbar-container',
        "imageResize": {
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
          }},
          "ImageCompress": {
            quality: 0.8,
            maxWidth: 900, 
            maxHeight: 900,
          },
          keyboard: {
            bindings: QuillBetterTable.keyboardBindings
          },
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          },
          mention: {
            mentionDenotationChars: ["@"],
            isolateCharacter: true,
            defaultMenuOrientation: "bottom",
            source: async (searchTerm, renderList) => this.userSelectSrv.renderUserList(searchTerm, renderList),
            onSelect: (item, insertItem) => this.userSelectSrv.onSelectUser(item, insertItem)
          }
      },
      theme: 'snow',
      
    })

    this.formatEditor = this.editor

    //Setzen von Textchange für speichern
    this.setSaveTextChange()
    
    //Setzen von Hotkeys
    this.editor.root.addEventListener("keydown", async (e: KeyboardEvent)=>{
      
      
      if((e.metaKey || e.ctrlKey) && (e.key == "s" || e.key == "Enter")){
        e.preventDefault()
        if(this.isMail) await this.saveEmail()
        else await this.saveAndClose()
        return
      }

      if((e.metaKey || e.ctrlKey) && e.altKey && e.code == "KeyT"){ 
       await this.openTextModules(e)
      }

    })

    //Setzen ob es Mail ist
    this.setIsMail()
   
  }

  private setSaveTextChange(){

    let removedBody = this.isNew ? "" : this.content.htmlText
    .replace("<body>", "")
    .replace("</body>", "")
    .replace("\t", "")

    if(this.isNew && !this.isModal){

      //Texte zwischenspeichern für den Fall, dass man ticket wechselt
      this.editor.on("text-change", ()=> this.ticketSrv.workstepContentsOnEdit.find(c => c.workstepId == this.ticketSrv.activeWorkstepId).htmlText = this.editor.root.innerHTML)
      this.editTextsSub = this.ticketSrv.newWorkstepSelected.subscribe((id: number)=>{
        if(id === null || !this.ticketSrv.hasWorkstepContentEditValue) return
        var delta = this.editor.clipboard.convert(this.ticketSrv.workstepContentsOnEdit.find(c => c.workstepId == id).htmlText)
        this.editor.setContents(delta, "silent")

        this.setContentFrom()
        setTimeout(() => this.editor.focus(), 600);
      })
    }else{
      this.setContentFrom()
      setTimeout(() => {
        var delta = this.editor.clipboard.convert(removedBody)
        this.editor?.setContents(delta, "silent")
      }, 0);
      setTimeout(() => this.editor.focus(), 600);
      if(!this.isNew){
        this.activeContentFrom = this.editSrv.contentFrom[this.content.from.type]
        if(!this.activeContentFrom) this.activeContentFrom = this.editSrv.contentFrom[0]
      }
    }

  }

  /**
   * Setzt ob es sich um eine Mail handelt
   */
  private setIsMail(){
    let content = !this.isModal ? 
      this.ticketSrv.workstepContentsOnEdit.find(c => c.workstepId == this.ticketSrv.activeWorkstepId) :
      {isMail: this.isMail, isNew: true}
    this.isMail = this.isMail ? true : content?.isMail || false
    if(this.isMail){
      this.emailSrv.emailTagsTo.changeDetector = this.changeDetector
      this.emailSrv.emailTagsCC.changeDetector = this.changeDetector
      this.emailSrv.emailTagsBCC.changeDetector = this.changeDetector
      if(content.isNew) this.emailSrv.setDefaults()
      this.mailSubscription = this.emailSrv.templateChanged.subscribe((result: {html: string, override?: boolean})=>{
        
        if(!result) return
        const savedText: string = this.ticketSrv.workstepContentsOnEdit.find(c => c.workstepId == this.ticketSrv.activeWorkstepId)?.htmlText

        this.editor.setContents(this.editor.clipboard.convert(savedText && !result.override ? savedText : result.html), "silent")
      })
      this.emailSrv.setTemplates().then(async (result: HttpFunctionResult<any>)=>{
        this.mailTemplateLoading = true 
        if(content.isNew) await this.emailSrv.setMailboxes()
        this.mailTemplateLoading = false 
        content.isNew = false
      })  
    }
  }

  ngOnDestroy(){
    if(this.editTextsSub) this.editTextsSub.unsubscribe()
    if(this.mailSubscription) this.mailSubscription.unsubscribe()
  }

  /**
   * Setzt von wem der Content kommt beim laden des Editors
   */
  private setContentFrom(){
    this.editSrv.contentFrom = []
    const user: {id: number, firstName: string, lastName: string, userName: string} = this.authSrv.getUser()
  

    if(this.authSrv.role == ROLE.employee){
      this.editSrv.addContentFrom({
        id: +user.id,
        type: 0,
        description: user?.firstName ? `${user?.firstName} ${user?.lastName}` : user.userName
      })
      
      this.editSrv.addContentFrom({
        id: this.ticketSrv.ticket.address.id,
        type: 1,
        description: this.ticketSrv.ticket.address.description
      })

      if(this.ticketSrv.contactPerson) this.editSrv.addContentFrom({
        id: this.ticketSrv.contactPerson.id,
        type: 2,
        description: `${this.ticketSrv?.contactPerson?.firstName} ${this.ticketSrv?.contactPerson?.lastName}`
      })
    } else if (this.authSrv.role == ROLE.customer){
      this.editSrv.addContentFrom({
        id: this.authSrv.getUser().id,
        type: 2,
        description: `${this.authSrv.getUser()?.firstName} ${this.authSrv.getUser()?.lastName}`
      })
    }

    this.activeContentFrom = this.editSrv.contentFrom[0]
  }

  /**
   * Schließt Editor
   * @param {WorkstepContent} data geschrieben Text wenn er vorher gespeichert wurde sonst null
   * @returns 
   */
  public async close(data: WorkstepContent = null){
    const plainText =this.editor.getText();
    if(data === null && (plainText != "" && plainText != "\n")){
      if(!(await this.feedback.confirm("Möchten Sie den geschriebenen Text wirklich verwerfen?", "Verwerfen", "Abbrechen"))) return
    }
    await this.feedback.hideKeyboardOnIOS()
    if(this.isModal)await this.modalCtrl.dismiss(data)
    else this.closed.next(data)
  }

  /**
   * Öffnet popover wo ausgewählt werden kann welche Art der geschriebene Content hat
   * @param {any} event Element was angeclickt wurde um popover dort zu öffnen 
   */
  public async selectArt(event: any){
    await this.feedback.openPopover<EditArt>(PopoverPage, event, {type: "ContentArt"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      if(this.isNew) this.isNewArt = result.data
      else this.content.art = result.data
    })
  }

  /**
   * Öffnet popover wo ausgewählt werden kann von wem dieser Text kommt
   * @param {any} event Element was angeclickt wurde um popover dort zu öffnen 
   */
  public async selectFrom(event: any){
    await this.feedback.openPopover<EditArt>(PopoverPage, event, {type: "ContentFrom"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.activeContentFrom = result.data  
    })
  }

  /**
   * Speichern geschriebenen Text und schließt anschließend die den Editor
   * @param {boolean} withMail Sagt ob nach speichern text in E-Mail-App geöffnet werden soll
   * @returns 
   */
  public async saveAndClose(withMail: boolean = false){

    await this.saveAddedEmployees()

    const plainText =this.editor.getText();

    const htmlText = `<body>${this.editor.root.innerHTML}</body>`

    if(this.isNew){
      const content: WorkstepContent = {
        id: this.isNew ? 0 : this.content.id,
        plainText: plainText,
        htmlText: htmlText,
        workstepId: this.ticketSrv.activeWorkstepId,
        ticketId: this.ticketSrv.ticket.id,
        art: this.isNewArt,
        from: this.activeContentFrom,
        taskId: this.taskId
      }

      //Abfragen ob Email an Kunden gesendet werden soll
      let sendMailToCustomer: boolean = false
      
      if(this.ticketSrv.ticket.onlineRelease && content.art.id != 4 && this.authSrv.includesRole("employee") &&  this.generalSrv.serverVersionGreaterThan("1.9.0")){
        if(this.generalSrv.webConfig.customerMailSend == CustomerLoginMailSendState.REQUEST){
          if(await this.feedback.confirm("Soll eine E-Mail an freigegebene Ansprechpartner gesendet werden?", "E-Mail senden", "Nein")) 
            sendMailToCustomer = true
        }else if(this.generalSrv.webConfig.customerMailSend == CustomerLoginMailSendState.ALWAYS) sendMailToCustomer = true
      }
      await this.feedback.updateLoading("Speichern...")
      const result: HttpFunctionResult<any> = await this.ticketSrv.createNewWorkstepContent(content, sendMailToCustomer)
      await this.feedback.hideLoading()
      if(result.success) await this.close(result.data)
      
    }else{
      this.content.plainText = plainText
      this.content.htmlText = htmlText
      this.content.from = this.activeContentFrom
      this.content.ticketId = this.ticketSrv.ticket.id
      const result: HttpFunctionResult<any> = await this.saveSrv.saveWorkstepContent(this.content)
      await this.feedback.hideLoading()
      if(result.success) {
        //if(withMail) await this.openMailApp()
        await this.close(this.content)
      } 
    }
  }


  /**
   * Fragt ab ob die Mitarbeiter, die hinzugefügt wurden dem Ticket hinzugefügt werden sollen
   * @returns 
   */
  private saveAddedEmployees(){
    if(this.authSrv.includesRole("customer")) return
    return new Promise(resolve=>{

      let useableEmployees: Employee[] = this.editSrv.employees.filter(e => this.ticketSrv.ticket.activeEmployees.find(ae =>ae == e.id))
      let toAddableEmployees: Employee[] = this.userSelectSrv.selectedEmployees.filter(e => {
        if(useableEmployees.find(ue => ue.id == e.id)) return false
        else return true
      })

      if(toAddableEmployees.length == 0)return resolve(null)

      this.feedback.openPopover<number[]>(MultiselectPage, null, {employees: toAddableEmployees}, (result: HttpFunctionResult<number[]>)=>{
        result.data.forEach(async (employeeId: number)=>{
          this.saveSrv.saveOrDeleteEditor(employeeId, true)

          this.ticketSrv.ticket.activeEmployees = [...this.ticketSrv.ticket.activeEmployees,  employeeId]
        })
        resolve(null)
      }, false)
    })
  }

  public insertUserselectOnCurrentPosition(){
    setTimeout(() => {

      const selection = this.editor.getSelection(true);
      this.editor.focus();
      this.editor.insertText(selection.index, " ")
      this.editor.insertText(selection.index + 1, '@');
      this.editor.blur();
      this.editor.focus();

      // const currentIndex: number = this.editor.getSelection().index;
      // this.editor.insertText(currentIndex, " ")
      // this.editor.insertText(currentIndex + 1, " @")
    
      // this.userselectSrv.handleAtPressed(currentIndex +1)
    }, 100);
  }

  public async addFileToMail(event: any){
    const list: PopoverListItem[] = [
      {id: 1, description: "Aus Ticket auswählen", icon: "fa-ticket"},
      {id: 2, description: "Externe Datei hinzufügen", icon: "fa-file"},
    ]
    await this.feedback.openPopover(PopoverPage, event, {list: list}, async (result: HttpFunctionResult<PopoverListItem>)=>{
      if(!result.success) return
      if(result.data.id == 1){
        const fileList: PopoverCheckListItem[] = this.ticketSrv.ticket.attachments.map(f => ({id: f.id, description: f.description, icon: "fa-file", checked: this.emailSrv.files.findIndex(file => file.ticketAttachment.id == f.id) >= 0}))
        await this.feedback.openPopover(CheckboxSelectComponent, event, {
          list: fileList,
          itemChecked: (item: PopoverCheckListItem) => {
            if(item.checked){
              const checkedAttachment: Attachment = this.ticketSrv.ticket.attachments.find(f => f.id == item.id)
              this.emailSrv.files.push({ticketAttachment: checkedAttachment, fileName: checkedAttachment.description})
            }else
              this.emailSrv.files.splice(this.emailSrv.files.findIndex(f => f.ticketAttachment.id == item.id), 1)
          }
        })
      }
      else this.fileInput.nativeElement.click()
    })
    
  }

  public async saveEmail(){
    const result: HttpFunctionResult<WorkstepContent> = await this.emailSrv.sendMail(this.editor)
    if(!result.success) return
    await this.close(result.data)
  }

  public async openTextModules(event: Event ){
    const {index} = this.editor.getSelection(true);
    
    await this.feedback.openModal(ContentTextModulePage, { }, async (result: HttpFunctionResult<TextSnippet>) => {
      if(!result.success) return

      await this.feedback.showLoading(async ()=>{
        const snippetResult: HttpFunctionResult<TextSnippet> = await this.textmodulesSrv.getSnippetById(result.data.id)
        if(!snippetResult.success) return
        
        let removedBody = snippetResult.data.content
            .replace("<body>", "")
            .replace("</body>", "")
            .replace("\t", "")

            setTimeout(() => this.editor.clipboard.dangerouslyPasteHTML(index || 0, removedBody), 0);


      }, "Laden...")
    }, true, undefined, "modal-content-text-module")
    // await this.feedback.openPopover(ContentTextModulePage, event, )
  }


}
